// extracted by mini-css-extract-plugin
export var root = "fcd3aa03669dd6eab67a1d38fa2f9437-css";
export var titleAndDragHandle = "_9a100f675980d7ca3bccf12b6c8d64de-css";
export var dragHandle = "cccccf14c3e7f834ace2bdbe6cd00846-css";